<template>
  <d-button @click="handleClick()" theme="clear" style="font-size: 1.82rem;">
    <i class="material-icons">&#xE5D2;</i>
  </d-button>
</template>

<script>
export default {
  name: "navbar-toggle",
  methods: {
    handleClick() {
      this.$emit("toggleSidebar");
    }
  }
};
</script>
